<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div>
		<transition appear appear-class="slide-fade-enter" appear-active-class="slide-fade-enter-active">
		<div class="mdc-card">
			<a :href="'/owners/' + owner.ownerId" @click.prevent="$router.push('/owners/' + owner.ownerId)">
			<section class="mdc-layout-grid applicants-list__box">
				<div class="mdc-layout-grid__inner">
					<div class="mdc-layout-grid__cell cell-6-xs applicants-list__info applicants-list__info-left">
						<div class="">
              <img :src="sourceFrom" v-if="sourceFrom" style="width:30px">
							<p class="applicants-list__info-left__name">{{owner.fullName}} <i v-if="owner.emailConfirmed || owner.mobileConfirmed" class="ico-checkmark applicants-list__checkmark"></i></p>
							<img v-if="hasPhoto" class="applicants-list__info-left__photo"/>
						</div>
					</div>
					<div class="mdc-layout-grid__cell cell-6-xs applicants-list__info applicants-list__info-right">
						<ul class="mdc-list">
							<!-- Property type -->
							<li class="mdc-list-item mdc-ripple-upgraded">
								<span class="mdc-list-item__text">
									<span class="applicants-list__info-right__details">
										<i class="ico-home"></i>{{owner.propsCount ? owner.propsCount : '--'}}
									</span>
								</span>
							</li>

						</ul>
					</div>
				</div>
			</section>
			</a>
		</div>
		</transition>
	</div>
</template>


<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';

export default {
	props: {
		value: Array,
		owner: [Object, Array],
		arrayIndex: Number
	},
	data: function() {
		return {
      sourceFrom: undefined,
			hasPhoto: false
		}
	},
  created: function() {

  },
	methods: {
		firstName(fullname) {
			return fullname.split(' ')[0];
		},
		getType(type) {
			if(type == 'flat') {
				return 'Flat';
			} else if(type == 'house') {
				return 'House';
			} else if(type == 'either') {
				return 'Flat & House';
			} else {
				return '--';
			}
		},
		getConsent(applicant) {
			let consent = '';
			if(owner.email) {
				consent = 'Email';
			}
			if(owner.mobile) {
				if(consent.length > 0) {
					consent += ' & ';
				}
				consent += 'Mobile';
			}
			return consent;
		}
	},
	mixins: [utils]
}
</script>



// WEBPACK FOOTER //
// src/components/OwnerBox.vue